






import { Component, Mixins } from 'vue-property-decorator'
import CustomerHeader from '@/components/organisms/CustomerHeader.vue'
import BootstrapLoader from '@/components/atoms/BootstrapLoader.vue'

@Component({
  components: {
    CustomerHeader,
  },
})
export default class AcademyLayout extends Mixins(BootstrapLoader) {
  private toggleBodyClass(addRemoveClass: string, className: string): void {
    const el = document.body

    if (addRemoveClass === 'addClass') {
      el.classList.add(className)
    } else {
      el.classList.remove(className)
    }
  }

  private mounted() {
    this.loadBootstrap()
    this.toggleBodyClass('addClass', 'academy')
  }

  private destroyed() {
    this.unloadBootstrap()
    this.toggleBodyClass('removeClass', 'academy')
  }
}
